import {
  INSTITUTE_LEGAL_STATUS_CHOICES,
  BASIC_SERVICE_CHOICES,
  IMPACT_METRIC_CHOICES,
  WORLD_REGION_CHOICES,
  SDGs
} from "utils/choices.jsx";

const schema = {
  title: "",
  description: "",
  type: "object",
  properties: {
    legal_status: {
      type: "string",
      title: "Type ",
      options: INSTITUTE_LEGAL_STATUS_CHOICES["TechnologyProvider"]
    },
    regions: {
      type: "string",
      title: "Region of Intervention ",
      options: WORLD_REGION_CHOICES
    },
    focus_areas: {
      type: "string",
      title: "Focus Areas ",
      options: BASIC_SERVICE_CHOICES
    },
    impact_metrics: {
      type: "string",
      title: "Relevant Impact Metrics ",
      options: IMPACT_METRIC_CHOICES
    },
    sustainable_development_goals: {
      type: "string",
      title: "Sustainable Development Goals",
      options: SDGs
    },
    region: {
      type: "string",
      title: "Region",
      options: WORLD_REGION_CHOICES
    }
  }
};

const uiSchema = [
  {
    container: "griditem",
    items: {
      region: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      sustainable_development_goals: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      legal_status: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      focus_areas: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  },
  {
    container: "griditem",
    items: {
      regions: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      },
      impact_metrics: {
        "ui:widget": "multiselect",
        "ui:emptyValue": ""
      }
    }
  }
];

export const TechnologyProviderFormSchema = {
  schema: schema,
  uiSchema: uiSchema
};
